import _ from 'lodash';
import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

const Filters = ({onFilterChange, filter, scenarios}) => {
    const startingYear = 2021;
    const currentYear = new Date().getFullYear();
    const years = _.range(startingYear, currentYear + 1);
    const months = _.range(1,13);

    const getMonthName = (month) => {
        return format(new Date(2000, month - 1, 1), "MMMM", {locale: enUS});
    }

    return (
        <div className="filters">
            <select
                name="year"
                id="year"
                value={filter.year}
                onChange={(e) => onFilterChange(e, 'year')}
            >
                {years.map((year) => (
                    <option value={year.toString()} key={year}>{year}</option>
                ))}
            </select>
            <select
                name="month"
                id="month"
                value={filter.month}
                onChange={(e) => onFilterChange(e, 'month')}
            >
                {months.map((month) => (
                    <option value={month.toString()} key={month}>{getMonthName(month)}</option>
                ))}
            </select>
            {scenarios && scenarios.length > 0 && (
                <select
                    name="scenario"
                    id="scenario"
                    value={filter.scenario || scenarios[0]?.scenario_id || ''}
                    onChange={(e) => onFilterChange(e, 'scenario')}
                >
                    {scenarios.length > 1 && <option value="">All scenarios</option>}
                    {scenarios.map((s) => (
                        <option value={s.scenario_id} key={s.scenario_id}>{s.name || s.scenario_id}</option>
                    ))}
                </select>
            )}
        </div>
    )
};

export default Filters;
